<template>
  <v-app >
    <!-- header   -->
    <header-component v-if="$store.getters.isLoggedIn" />
    <v-main>
      <v-container class="p-0">
        <router-view></router-view>
      </v-container>
    </v-main>
    <!--  footer  -->
    <footer-component />
  </v-app>
</template>

<script>
import HeaderComponent from "@/components/shared/Header.vue";
import FooterComponent from "@/components/shared/Footer.vue";

export default {
  name: 'AdminLayout',
  components: {FooterComponent, HeaderComponent},

}
</script>
